import axios, { AxiosInstance } from 'axios'

import { config } from '../configs/api.config'

import { configureClient } from './api-utils'

let client: AxiosInstance

export interface HubspotCompany {
  company_id: string
  company_name: string | null
  domain: string | null
}

export interface HubspotCompaniesResponse {
  results: HubspotCompany[]
  total: number
}

export interface HubspotOrganizationData {
  company_id: string
  company_name: string | null
  domain: string | null
  current_mrr: string | null
  potential_mrr: string | null
  company_size: string | null
  pricing_tier: string | null
  lifecyclestage: string | null
  industry: string | null
  numberofemployees: string | null
  customer_number: string | null
  no_of_users: string | null
  activation_rate: string | null
  active_features: string | null
  usecases_implemented: string | null
  buyer_journey: string | null
  country: string | null
  city: string | null
  properties: Record<string, unknown> | null
}

export const getOrganizationHubspotClient = () => {
  if (!client) {
    client = axios.create({
      baseURL: config.ORGANIZATION
    })

    configureClient(client, {
      baseURL: config.ORGANIZATION
    })
  }

  return client
}

export const organizationHubspotClient = {
  getHubspotCompanies: async (
    search?: string,
    limit: number = 100
  ): Promise<HubspotCompaniesResponse> => {
    const client = getOrganizationHubspotClient()
    const params: Record<string, string | number> = { limit }

    if (search) {
      params.search = search
    }

    const response = await client.get<HubspotCompaniesResponse>(
      '/v2/hubspot/companies',
      { params }
    )

    return response.data
  },

  getOrganizationHubspotData: async (
    orgId: string
  ): Promise<HubspotOrganizationData | null> => {
    const client = getOrganizationHubspotClient()

    try {
      const response = await client.get<HubspotOrganizationData>(
        `/v2/organizations/${orgId}/hubspot-data`
      )

      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return null
      }

      throw error
    }
  },

  getHubspotCompanyById: async (
    companyId: string
  ): Promise<HubspotCompany | null> => {
    const client = getOrganizationHubspotClient()

    try {
      const response = await client.get<HubspotCompany>(
        `/v2/hubspot/companies/${companyId}`
      )

      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return null
      }

      throw error
    }
  }
}
